import axios from 'axios';
import config from '@/config/env-constants';

export default {

    getStorageLocations(filterBy, view, currUserId, pagination = {}) {
        const url = `${config.cloudFunctionsBaseUrl}/getStorageLocations`;
        return axios.post(url, {
            view: view,
            currUserId: currUserId,
            filterBy: JSON.stringify(filterBy),
            search: pagination.search,
            page: pagination.page,
            pageSize: pagination.pageSize,
        });
    },

    paginateStorageLocations(param) {
        const url = `${config.cloudFunctionsBaseUrl}/paginateStorageLocations`;
        return axios.post(url, {
            currUserId: param.currUserId,
            filterBy: JSON.stringify(param.filterBy),
            view: param.view,
            page: param.page,
            limit: param.limit,
            startAt: param.startAt,
            direction: param.direction
        });
    },

    saveStorageLocation(storageLocation, currUserId, currTimeStamp) {
        const url = `${config.cloudFunctionsBaseUrl}/saveStorageLocation`;
        return axios.post(url, {
            currUserId: currUserId,
            currTimeStamp: currTimeStamp,
            storageLocation: JSON.stringify(storageLocation)
        });
    },

}